import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur många försök har jag på kunskapsprovet?";
const SHORT_ANSWER = "Du har normalt två försök per ansökan. Underkänns du på båda måste en ny ansökan lämnas in.";

export const Route = createFileRoute("/fraga/hur-manga-forsok-har-jag")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur många försök har jag på kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Det är därför viktigt att gå in förberedd – chansa inte med första försöket. Många bokar dessutom omprovet med tre veckors mellanrum för att hinna repetera."}
      source={{ label: "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", href: "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/underkand-pa-kunskapsprovet", label: "Underkänd på kunskapsprovet – vad nu?" }}
      related={[{"to": "/fraga/vad-hander-om-jag-blir-underkand", "label": "Vad händer om jag blir underkänd på kunskapsprovet?"}, {"to": "/fraga/var-bokar-jag-provet", "label": "Var bokar jag kunskapsprovet?"}, {"to": "/fraga/kostar-kunskapsprovet-extra", "label": "Kostar kunskapsprovet extra utöver ansökan?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur många försök har jag på kunskapsprovet?" },
      { name: "description", content: "Du har normalt två försök per ansökan. Underkänns du på båda måste en ny ansökan lämnas in." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-manga-forsok-har-jag" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-manga-forsok-har-jag" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-manga-forsok-har-jag",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur många försök har jag på kunskapsprovet", url: "https://alkoholprovet.se/fraga/hur-manga-forsok-har-jag" },
      ]),
    ],
  }),
});
